import PubSub from "underpub-js";

var Header = function (options) {

  this.options = {
    $el: false,
    baseClass: 'mol-Header',
  };

  $.extend(true, this.options, options);

};

Header.prototype.init = function () {

  var self = this;

  self.$hamburger = self.options.$el.find(
    `.${self.options.baseClass}__hamburger`,
  );

  self.$hamburger.on('click', () => {
    PubSub.publish('NavigationPopup__toggle');
  });

};



window.addEventListener('scroll', function () {
  const header = document.querySelector('.mol-sticky');
  if (window.scrollY > 0) {
    header.classList.add('sticky');
  } else {
    header.classList.remove('sticky');
  }
});


export default Header;